'use strict';

import { UIDiv, UIElement, UISpan } from '@ui';

export class Collapse extends UIDiv {
  constructor({
    title = '' || new UIElement(),
    content,
    togglePos = 'front',
    isOpen = false,
  } = {}) {
    super();

    this.title = title;
    this.content = content;
    this.isOpen = isOpen;
    this.togglePos = togglePos;
    this.render();
  }

  render() {
    this.setClass('border border-gray-300 rounded-md w-full overflow-hidden');

    this.header = new UIDiv();
    this.header.setClass(
      'collapse-header flex justify-between items-center p-4 cursor-pointer',
    );
    if (this.title instanceof UIElement) {
      this.header.add(this.title);
    } else {
      this.header.setValue(this.title);
    }
    this.add(this.header);

    this.contentDiv = new UIDiv();
    this.contentDiv.setClass(
      `transition-all duration-300 ease-in-out origin-top ${
        this.isOpen
          ? 'max-h-[10000px] opacity-100 p-4'
          : 'max-h-0 opacity-0 p-0'
      }`,
    );
    if (this.content instanceof UIElement) {
      this.contentDiv.add(this.content);
    } else {
      this.contentDiv.setValue(this.content);
    }
    this.add(this.contentDiv);

    this.header.onClick(this.toggle.bind(this));

    this.chevron = new UISpan();
    this.chevron.setClass('transition-transform duration-300');
    this.chevron.setValue('▼');
    this.chevron.setStyle('transform', [
      this.isOpen ? 'rotate(180deg)' : 'rotate(0deg)',
    ]);

    if (this.togglePos === 'back') {
      this.header.add(this.chevron);
    } else {
      this.header.addFront(this.chevron);
    }
  }

  toggle() {
    this.isOpen = !this.isOpen;
    if (this.isOpen) {
      this.contentDiv.setClass(
        'transition-all duration-300 ease-in-out origin-top max-h-[10000px] overflow-scroll opacity-100 p-4',
      );
    } else {
      this.contentDiv.setClass(
        'transition-all duration-300 ease-in-out origin-top max-h-0 opacity-0 p-0',
      );
    }
    this.chevron.setStyle('transform', [
      this.isOpen ? 'rotate(180deg)' : 'rotate(0deg)',
    ]);
  }
}
